import { render, staticRenderFns } from "./mlist.vue?vue&type=template&id=3dd3f092&scoped=true&"
import script from "./mlist.vue?vue&type=script&lang=js&"
export * from "./mlist.vue?vue&type=script&lang=js&"
import style0 from "./mlist.vue?vue&type=style&index=0&id=3dd3f092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd3f092",
  null
  
)

export default component.exports